import { registerLocaleData } from '@angular/common';
import localeSrLatn from '@angular/common/locales/sr-Latn';
import localeEnGb from '@angular/common/locales/en-GB';
import localeDa from '@angular/common/locales/da';
import localeNb from '@angular/common/locales/nb';
import localeIt from '@angular/common/locales/it';
import localeDe from '@angular/common/locales/de';
import localeFr from '@angular/common/locales/fr';
import localeHr from '@angular/common/locales/hr';
import localeEs from '@angular/common/locales/es';
import localeSv from '@angular/common/locales/sv';
import localeRu from '@angular/common/locales/ru';
import localeAr from '@angular/common/locales/ar';
import { LOCALE_ID } from '@angular/core';
import { appInit } from '../../../libs/shared/src/functions/appInitLang';

import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import { buildCspDirectives } from '@anihis/shared/src/constants/security.constants';
import { of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';

registerLocaleData(localeSrLatn, 'sr-Latn');
registerLocaleData(localeEnGb, 'en-GB');
registerLocaleData(localeDa, 'da-DK');
registerLocaleData(localeNb, 'nb-NO');
registerLocaleData(localeIt, 'it-IT');
registerLocaleData(localeDe, 'de-DE');
registerLocaleData(localeFr, 'fr-FR');
registerLocaleData(localeHr, 'hr-HR');
registerLocaleData(localeEs, 'es-ES');
registerLocaleData(localeSv, 'sv-SE');
registerLocaleData(localeRu, 'ru-RU');
registerLocaleData(localeAr, 'ar-SA');
registerLocaleData(localeSrLatn, 'sr');
registerLocaleData(localeEnGb, 'en');
registerLocaleData(localeDa, 'da');
registerLocaleData(localeNb, 'nb');
registerLocaleData(localeIt, 'it');
registerLocaleData(localeDe, 'de');
registerLocaleData(localeFr, 'fr');
registerLocaleData(localeHr, 'hr');
registerLocaleData(localeEs, 'es');
registerLocaleData(localeSv, 'sv');
registerLocaleData(localeRu, 'ru');
registerLocaleData(localeAr, 'ar');

// Suppress console output in non-development environments
if (environment.production || environment.disableConsole) {
  const noop = () => {};
  console.log = noop;
  console.debug = noop;
  console.warn = noop;
  console.info = noop;
  console.error = noop;
  console.dir = noop;
  console.table = noop;
}

// Build and inject CSP meta tag at runtime — LOCAL DEV ONLY.
// In production and QA the server response header (staticwebapp.config.json /
// staticwebapp.config.qa.json) is the authoritative CSP source. Adding a meta
// tag alongside a server header causes the browser to apply the most-restrictive
// intersection of both, which would silently remove permissions granted by the
// server header (e.g. 'unsafe-inline' for Quill / Google APIs).
if (!environment.production && !environment.disableConsole) {
  of(null)
    .pipe(
      map(() =>
        buildCspDirectives(environment.apiUrl, environment.portalUrl, [], {
          allowUnsafeEval: true,
          allowUnsafeInline: true,
          extraStyleSrc: ['https://fonts.googleapis.com'],
          extraFontSrc: ['https://fonts.gstatic.com'],
          extraScriptSrc: [],
          extraImgSrc: ['http://127.0.0.1:10000'],
          extraMediaSrc: ['http://127.0.0.1:10000'],
          includeFrameAncestors: false,
        }),
      ),
      tap((csp) => {
        const entries = Object.entries(csp).filter(
          ([k]) => k !== 'frame-ancestors',
        );
        const cspContent = entries
          .map(([k, v]) => (typeof v === 'boolean' && v ? k : `${k} ${v}`))
          .join('; ');

        let meta: HTMLMetaElement | null = document.querySelector(
          'meta[http-equiv="Content-Security-Policy"]',
        );
        if (!meta) {
          meta = document.createElement('meta');
          meta.setAttribute('http-equiv', 'Content-Security-Policy');
          document.head.appendChild(meta);
        }
        meta.setAttribute('content', cspContent);
      }),
      catchError(() => of(null)),
    )
    .subscribe();
}

bootstrapApplication(AppComponent, {
  ...appConfig,
  providers: [
    ...appConfig.providers,
    { provide: LOCALE_ID, useValue: appInit() },
  ],
}).catch((err) => console.error(err));
